import { firestoreDb } from './firebase';
import {
    getFirestore,
    collection,
    addDoc,
    onSnapshot,
    serverTimestamp,
    doc,
    deleteDoc
} from 'firebase/firestore';

class FirebaseRemote {
    constructor(sessionId) {
        // console.log('sessionId:', sessionId, typeof sessionId);  // should be string
        this.commandsCol = collection(firestoreDb, 'commands', sessionId, 'commands');
    }

    sendCommand(command, payload = {}) {
        return addDoc(this.commandsCol, {
            command,
            payload,
            createdAt: serverTimestamp()
        });
    }
}

export default FirebaseRemote;